import { Component, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'toggle-slide',
  templateUrl: './toggle-slide.component.html',
  standalone: false,
})
export class ToggleSlideComponent implements AfterViewInit {
  options = ['0', '1'];
  @Output() selectedOption = new EventEmitter();
  @Input() activeIndex = '0';

  @ViewChild('slider') slider: ElementRef<HTMLElement>;
  @ViewChild('slidingOptions') slidingOptions: ElementRef<HTMLElement>;

  optionItems: NodeListOf<HTMLAnchorElement>;

  constructor() {}

  ngAfterViewInit(): void {
    if (this.options && this.options.length > 0) {
      this.optionItems = this.slidingOptions.nativeElement.querySelectorAll('a');
      this.setSlide(this.activeIndex);
    }
  }

  setSlide(indexToSlide) {
    if (indexToSlide === '0') {
      this.optionItems[indexToSlide].parentElement.parentElement.classList.remove('-on');
    } else {
      this.optionItems[indexToSlide].parentElement.parentElement.classList.add('-on');
    }
    this.slider.nativeElement.style.zIndex = '1';
    this.slider.nativeElement.style.left = this.optionItems[indexToSlide].parentElement.offsetLeft + 'px';
    this.slider.nativeElement.style.width = this.optionItems[indexToSlide].parentElement.offsetWidth + 'px';
  }

  toggleHandler() {
    const newActiveIndex = this.activeIndex === '0' ? '1' : '0';
    this.setSlide(newActiveIndex);
    this.activeIndex = newActiveIndex;
    this.selectedOption.emit(this.activeIndex);
  }
}